import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PostHeadersInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only default the Content-Type when the caller hasn't set one. The OIDC token
        // request (angular-oauth2-oidc) explicitly sends
        // application/x-www-form-urlencoded with a `grant_type=...` body; blindly forcing
        // application/json here mislabels it and the AS's json body-parser then fails with
        // "grant_type... is not valid JSON". Normal app POSTs don't set a Content-Type at
        // this stage (Angular adds it after interceptors), so they still get JSON.
        if (req.method == 'POST' && !req.reportProgress && !req.headers.has('Content-Type')) {
            req = req.clone({
                headers: req.headers.set('Content-Type', 'application/json')
            });
        }
        return next.handle(req);
    }

}